"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = void 0;
var _react = _interopRequireDefault(require("react"));
var _HeaderContainer = require("./HeaderContainer");
var _body = require("./body");
var _layout = require("../../layout");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Layout = function Layout(_ref) {
  var children = _ref.children,
    Header = _ref.headerComponent,
    Footer = _ref.footerComponent,
    BodyContainerComponent = _ref.bodyContainerComponent;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "min-vh-100 d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement(_HeaderContainer.HeaderContainer, null, /*#__PURE__*/_react.default.createElement(Header, null)), /*#__PURE__*/_react.default.createElement(BodyContainerComponent, {
    className: "flex-grow-1"
  }, /*#__PURE__*/_react.default.createElement(_body.Body, null, children)), /*#__PURE__*/_react.default.createElement(_layout.LayoutFooterContainer, null, /*#__PURE__*/_react.default.createElement(Footer, null)));
};
exports.Layout = Layout;